import React from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature9 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.right.box.children;
      return itemLists.map((key) => {
        const { title, img, ...other } = key;
        return (
          <div {...other} key={title.children}>
            <div {...img}>
              <img src={img.children} alt="" />
            </div>
            <div {...title}>
              <span dangerouslySetInnerHTML={{ __html: title.children }} />
            </div>
          </div>
        );
      }
      );
    }

    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.page}>
          <OverPack
            {...dataSource.content}
          >
            <TweenOne
              animation={{
                x: 0,
                duration: 300,
              }}
              style={{ transform: 'translateX(-600px)' }}
              key="img"
              {...dataSource.content.left}
              data-edit="image"
            >
              <img src={dataSource.content.left.children} width="100%" alt="img" />
            </TweenOne>
            <TweenOne
              animation={{
                x: 0,
                duration: 300,
              }}
              style={{ transform: 'translateX(600px)' }}
              {...dataSource.content.right}
            >
              <div {...dataSource.content.right.title}>
                {
                dataSource.content.right.title.children.map(getChildrenToRender)
              }
              </div>
              <QueueAnim
                {...dataSource.content.right.box}
                delay={200}
                duration={400}
              >
                {getItem()}
              </QueueAnim>
            </TweenOne>
          </OverPack>
        </div>

      </div>
    );
  }
}
export default Feature9;
